import { SENS_VENTE, MODULE_GESTION_COMMERCIALE } from '@/configuration/devisConf';

export default function genererRemiseBancaire() {
  return {
    nom: null,
    dateRemise: new Date(),
    domiciliationBancaireId: null,
    modeReglementId: null,
    societeId: null,
    sens: SENS_VENTE,
    module: MODULE_GESTION_COMMERCIALE,
  };
}
